const pagesIndividualAccountsEn = {
  headers: {
    actualRoleName: 'Role',
    app: 'App',
    category: 'Category',
    createdAt: 'Created',
    displayName: 'Display Name',
    lastSignIn: 'Last Sign-in',
    mfa: 'MFA',
    tenantName: 'Tenant'
  },
  mfa: {
    disabled: 'Off',
    enabled: 'On'
  },
  pageTitle: 'Accounts',
  tabs: {
    self: 'My Accounts'
  }
};
export default pagesIndividualAccountsEn;